import { gql } from '@apollo/client';

import { ADDRESS_FRAGMENT, BRAND_FRAGMENT } from './';

export default gql`
  fragment brandFullFragment on Brand {
    ...brandFragment
    status
    createdAt
    address {
      ...addressFragment
    }
  }
  ${ADDRESS_FRAGMENT}
  ${BRAND_FRAGMENT}
`;
